<template>
  <div v-loading="listContentLoading">
    <el-button
      v-if="showBack"
      style="padding: 0; margin: 20px;"
      type="text"
      icon="el-icon-back"
      @click="$router.go(-1)"
    >
      返回
    </el-button>

    <el-select
        v-if="!showBack"
        class="search-el"
        size="mini"
        v-model="channel_id"
        placeholder="请选择渠道"
        clearable
        filterable
        @change="channelChange($event)"
    >
      <el-option label="全部渠道" value="-1"></el-option>
      <el-option
          v-for="item in channelList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
      >
      </el-option>
    </el-select>

    <el-select
        v-if="!showBack"
        class="search-el"
        size="mini"
        v-model="channel_item_id"
        placeholder="请选择推广位"
        clearable
        filterable
        @change="channelItemChange($event)"
    >
    <el-option label="全部推广位" value="-1"></el-option>
      <el-option
          v-for="item in channelItemList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
      >
      </el-option>
    </el-select>

    <el-date-picker
      size="mini"
      v-model="query.begin_at"
      format="yyyy-MM-dd"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择开始时间"
    >
    </el-date-picker
    >~
    <el-date-picker
      size="mini"
      v-model="query.end_at"
      format="yyyy-MM-dd"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择结束时间"
    >
    </el-date-picker>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.status"
      clearable
      placeholder="订单状态"
    >
      <el-option label="全部" value="-1">全部</el-option>
      <el-option label="已支付" value="2">已支付</el-option>
      <el-option label="待支付" value="1">待支付</el-option>
      <el-option label="已取消" value="0">已取消</el-option>
      <el-option label="支付中" value="6">支付中</el-option>
      <el-option label="已退款" value="5">已退款</el-option>
    </el-select>

    <el-input
      class="search-el"
      size="mini"
      v-model="query.search"
      clearable
      placeholder="请输入用户id/商品名称/订单号"
    ></el-input>

    <el-button type="primary" size="mini" @click="channelOrderList()">
      查询</el-button
    >

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column label="订单信息" align="center" min-width="20%">
          <template slot-scope="{ row }">
            <div>{{ row.body }}<br />订单号: {{ row.order_no }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="event_user_nickname"
          label="订单导购"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="total_amount"
          label="实付金额"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="paid_at"
          label="付款时间"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="user_id"
          label="用户ID"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="order_status_msg"
          label="状态"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column label="渠道（推广位）" align="center" min-width="15%">
            <template slot-scope="{ row }">
              <div>{{ showChannelItemName(row.source) }}</div>
            </template>
          </el-table-column>

      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="channelOrderList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { channelOrderList, getChannelList, getChannelItemList } from "@/api/cChannel";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        code: "",
        search: "",
        status: '',
        begin_at: "",
        end_at: "",
      },
      channel_id: '',
      channel_item_id: '',
      showBack: false,
      channelList: [],
      channelList1: [],
      channelItemList: [],
      channelItemList1: [],

      listContentLoading: false,
    };
  },
  created: function () {
    if (this.$route.query.code != undefined) {
      this.query.code = this.$route.query.code;
      this.showBack = true;
    } else {
      this.query.code = 'CH\\_';
    }    

    getChannelList({ only_name: 1 }).then((response) => {
      this.channelList = response.data;
      response.data.forEach((item) => {
        this.channelList1[(item.id).toString()] = item.name;
      });
    });
    getChannelItemList({ only_name: 1 }).then((response) => {
      this.channelItemList = response.data;
      response.data.forEach((item) => {
        this.channelItemList1[(item.id).toString()] = item.name;
      });
    });

    this.channelOrderList();
  },
  methods: {
    showChannelItemName(source) {
      var arr = source.split('_');
      return this.channelList1[arr[1]] + '【' + this.channelItemList1[arr[2]] + '】';
    },
    channelChange(channel_id) {
      this.channel_id = channel_id;
      if (channel_id > 0) {
        this.query.code = 'CH\\_' + channel_id.toString();
        getChannelItemList({ only_name: 1, channel_id:  channel_id}).then((response) => {
          this.channelItemList = response.data;
        });
      } else {
        this.query.code = 'CH\\_';
        this.channelItemList = [];
      }
    },
    channelItemChange(channel_item_id) {
      this.channel_item_id = channel_item_id;
      if (channel_item_id > 0) {
        this.query.code = 'CH_' + this.channel_id.toString() + '_' + this.channel_item_id.toString();
      } else {
        this.query.code = 'CH\\_' + this.channel_id.toString();
      }
    },
    channelOrderList() {
      this.loading = true;
      channelOrderList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
  },
  mounted() {},
};
</script>
